<div id="license_validation"><h4 *ngIf="showTitle">Your Address Information</h4>
  <form>
    <tgf-form-control-question-processor
      [parentModel]="actualModel"
      [form]="questionForm" [questionJson]="questionJson">
    </tgf-form-control-question-processor>
    <ng-container *ngIf="requiresValidation">
      <div class="d-flex">
        <button
          type="button"
          class="sd-btn sd-btn--action me-2"
          (click)="validateAddress()">
          Validate Address
        </button>
        <p *ngIf="canShowAddressValid()"
          class="success-message"
          ><i class="color-success fa-solid fa-circle-check me-2"
          ></i>Your address is valid</p>
      </div>
    </ng-container>

  </form>
</div>

<tg-spinner [blockAll]="true" *ngIf="isItLoading()"></tg-spinner>
